<template>
    <v-container tag="section" id="custom_content">
        <v-row>
            <v-col class="pt-sm-8 pb-sm-8 pt-3 pb-6">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col :class="index > 0 ? 'pb-0 pt-8' : 'py-0'" class="d-flex" v-for="(item, index) in custom" :key="item.id">
                <v-row no-gutters >
                    <v-col cols="12" sm="6" v-if="item.image">
                        <v-img 
                            height="100%"
                            :src="item.image.imageURL" 
                            :alt="item.image.imageAlt"></v-img>
                    </v-col>
                    <v-col cols="12" :sm="item.image ? 6 : 12" class="px-0 py-0">
                        <div class="custom__container" v-html="item.content">
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        data() {
            return {
                custom: []
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.custom)
                .then(response => {
                    this.custom = response.data
                })
                .catch(error => console.log('Failed to update from MOH', error))
        }
    }
</script>

<style lang="scss">
    #custom_content {

        .custom__container {
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: 56%;

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        .d-flex .v-card {
            flex: 1 1 auto;
        }
    }
</style>